import appIconUrl from '../../assets/img/instapaper-app-icon.png';
import logoUrl from '../../assets/img/instapaper-logo.svg';

interface BrandAsset {
  /** Built asset URL (same-origin), used for both preview and download. */
  href: string;
  /** Suggested filename for the download. */
  downloadName: string;
  name: string;
  format: string;
  /** Modifier class so the preview can size the logo and the icon differently. */
  previewClass: string;
  alt: string;
}

/**
 * Press-kit brand assets: the Instapaper wordmark (SVG) and app icon (PNG),
 * shown on a fixed light swatch (the art is full-color brand work, not
 * theme-aware) with a one-click download for each. Rendered via the
 * `{{press_brand_assets}}` doc token (see remarkDocTokens).
 */
function BrandAssetsSection() {
  const assets: BrandAsset[] = [
    {
      href: logoUrl,
      downloadName: 'instapaper-logo.svg',
      name: 'Wordmark',
      format: 'SVG',
      previewClass: 'docs-brand-asset-logo',
      alt: 'Instapaper logo',
    },
    {
      href: appIconUrl,
      downloadName: 'instapaper-app-icon.png',
      name: 'App icon',
      format: 'PNG · 512×512',
      previewClass: 'docs-brand-asset-icon',
      alt: 'Instapaper app icon',
    },
  ];

  return (
    <div className="docs-brand-assets">
      {assets.map((asset) => (
        <div key={asset.downloadName} className="docs-brand-asset">
          <div className={`docs-brand-asset-preview ${asset.previewClass}`}>
            <img src={asset.href} alt={asset.alt} />
          </div>
          <div className="docs-brand-asset-meta">
            <div className="docs-brand-asset-info">
              <span className="docs-brand-asset-name">{asset.name}</span>
              <span className="docs-brand-asset-format">{asset.format}</span>
            </div>
            <a
              href={asset.href}
              download={asset.downloadName}
              className="docs-brand-download"
            >
              Download
            </a>
          </div>
        </div>
      ))}
    </div>
  );
}

export default BrandAssetsSection;
